import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Carl extends Lit3formBlock {
  static get characterName() {
    return 'carl';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid carl-layout">
          <div class="drivers">
            ${this.imagesArr.map(i => this.driverHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  driverHTML(driver) {
    return html`
      <div class="driver-wrapper">
        <div class="driver-image">
          <img src=${this.imageUrl(driver)} />
        </div>
        <div class="driver-info">
          <p class="eyebrow">${this.driverData(driver, 'eyebrow')}</p>
          <h2 class="title">${this.driverData(driver, 'title')}</h2>
          <p class="description">${this.driverData(driver, 'description')}</p>
          ${this.ctaHTML(driver)}
        </div>
      </div>
    `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  driverData(driver, param) {
    return unsafeHTML(this.withLineBreaks(driver[param])) || '';
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 700, null);
  }

  hasCta(driver) {
    return driver.url && driver.text;
  }

  ctaInfo(driver) {
    return JSON.stringify({ url: driver.url, text: driver.text });
  }

  ctaHTML(driver) {
    return this.hasCta(driver)
      ? html`
          <cta-button
            class="cta-btn details-row"
            cta-data=${this.ctaInfo(driver)}
            cta-type="secondary"
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaInfo,
              driver.text
            )}
          ></cta-button>
        `
      : ``;
  }
}
Carl.defineElement();
